module.exports = __webpack_public_path__ + "img/logo-dark.688e12d6.svg";